<template>
<v-app>
  <v-container>
    <v-card width="30%">
      <v-card-title>收款工具</v-card-title>
      <v-card-text>
        <v-radio-group v-model="row" row>
          <v-radio label="合庫刷卡" value="tcb"></v-radio>
          <v-radio label="國泰刷卡" value="cathay"></v-radio>
          <v-radio label="超商繳款單" value="market"></v-radio>
        </v-radio-group>

        <v-layout>
          <v-flex>
            <v-text-field v-model="payment.productName"
                          placeholder="請輸入商品名稱" label="商品名稱">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-autocomplete v-model="payment.storeId"
                            :items="getECUStoreList"
                            item-text="name"
                            item-value="storeId"
                            :readonly="false"
                            label="商店，經銷商"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field  v-model="payment.customerName"
                           :label="row === 'tcb' ? '持卡人姓名':'顧客姓名'"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-if="row === 'market'">
          <v-flex>
            <v-text-field  v-model="memberId"
                           label="身分證(選填)"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-if="row === 'market'">
          <v-flex>
            <v-text-field  v-model="cellphone"
                           label="手機號碼(必填)"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-select
              :items="options"
              item-value="key"
              item-text="value"
              label="是否分期"
              v-model="payment.PeriodNum">
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field v-model="payment.price"
                          :placeholder="row === 'tcb' ? '請輸入刷卡金額':'請輸入月付金額'" :label="row === 'tcb' ? '請輸入刷卡金額':'請輸入月付金額'">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-if="row === 'market'">
          <date-picker :date-string="`首期繳款日`" :date.sync="firstPaymentDate"/>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field v-model="payment.comment"
                          label="備註"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout v-if="paymentURL !== ''">
          <v-flex>
            <v-text-field v-model="paymentURL"
                          label="繳款單連結"
            ></v-text-field>
          </v-flex>
        </v-layout>

      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" :loading="loading" @click="submit">
          送出
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import common from '../../mixins/common';
import { addMonth, getCurrentDate, getUUId } from '../utils/tool';
import DatePicker from "../../components/DatePicker";

export default {
  name: 'TCBPayment',
  components: {
    DatePicker
  },
  data(){
    return {
      row: 'tcb',
      firstPaymentDate: getCurrentDate(),
      payment: {
        orderId: new Date().getTime(),
        productName: '',
        price: 0,
        responseURL: 'https://haorich.tw/payment/tcb/result/',
        // responseURL: 'http://172.16.6.111:3000/payment/tcb/result/',
        MerchantName: '',
        PayType: 0,
        PeriodNum: 0,
        comment:'',
        storeId: '',
        customerName: '',
        agentId: '',
        status: -1,
      },
      loading: false,
      memberId: '',
      cellphone: '',
      paymentURL: '',
    };
  },
  created() {
    this.loadStoreData();
  },
  mixins:[common],
  watch:{
    'payment.storeId'(value){
      if(value !== ''){
        const find = this.getECUStoreList.find(s=>s.storeId === value);
        if (find){
          this.payment.MerchantName = find.name;
        }
      }
    }
  },
  computed:{
    ...mapGetters(['getECUStoreList']),
    options(){
      if (this.row === 'tcb'){
        return [
          { key: 0 , value: '一次付清'},
          { key: 3 , value: '3期'},
          { key: 6 , value: '6期'},
          { key: 12 , value: '12期'},
          { key: 18 , value: '18期'},
          { key: 24 , value: '24期'}
        ]
      } else {
        return [
          { key: 0 , value: '一次付清'},
          { key: 3 , value: '3期'},
          { key: 6 , value: '6期'},
          { key: 12 , value: '12期'},
          { key: 18 , value: '18期'},
          { key: 24 , value: '24期'},
          { key: 36 , value: '36期'},
          { key: 48 , value: '48期'}
        ]
      }
    }
  },
  methods:{
    ...mapActions(['savePreparePaymentInfo', 'fetchECUStoreList', 'saveMarketPaymentInfo', 'getCathayCreditInfo']),
    loadStoreData(){
      if (this.isAdmin) {
        this.fetchECUStoreList({ orderBy: 'desc', status: -1, agentId: this.getUserInfo.agentId });
      } else {
        this.fetchECUStoreList({ orderBy: 'desc', status: 0, agentId: this.getUserInfo.agentId });
      }
    },
    async submit(){
      console.log(`submit`);
      if (!this.payment.price || this.payment.price === '' || this.payment.price === 0){
        alert('請輸入金額')
        return;
      }
      if (this.row === 'tcb'){
        await this.savePreparePayment();
      } else if(this.row === 'cathay'){
        await this.getPreparePayment();
      }else if (this.row === 'market'){
        if (!this.cellphone || this.cellphone === ''){
          alert('請輸入手機號碼')
          return;
        }
        this.createMarketPayment();
      }
    },
    // 合庫
    async savePreparePayment(){
      this.payment.agentId = this.getUserInfo.agentId;
      this.payment.orderId = new Date().getTime();
      this.payment.PayType = this.payment.PeriodNum === 0 ? 0 : 1;
      const res = await this.savePreparePaymentInfo(this.payment);
      const result = res.data;
      if (result.statusCode === 0){
        this.sendTCBPayment();
      }
    },
    async getPreparePayment(){
      this.payment.agentId = this.getUserInfo.agentId;
      this.payment.orderId = new Date().getTime();
      this.payment.PayType = this.payment.PeriodNum === 0 ? 0 : 1;
      const res = await this.getCathayCreditInfo(this.payment);
      const result = res.data;
      if (result.statusCode === 0){
        console.log(`getCathayCreditInfo == ${JSON.stringify(result.data)}`);
        this.sendCathayPayment(result.data);
      }
    },
    sendCathayPayment(data){
      this.formPost('https://sslpayment.uwccb.com.tw/EPOSService/Payment/OrderInitial.aspx', data);
    },
    sendTCBPayment(){
      // PRD https://www.focas.fisc.com.tw/FOCAS_WEBPOS/online/
      // test https://www.focas-test.fisc.com.tw/FOCAS_WEBPOS/online/
      this.formPost('https://www.focas.fisc.com.tw/FOCAS_WEBPOS/online/', {
        MerchantID:'006546386319001',
        lidm: this.payment.orderId,
        TerminalID:'90010001',
        merID:'54638631',
        AutoCap: 1,
        purchAmt: this.payment.price,
        AuthResURL: this.payment.responseURL,
        PayType: this.payment.PeriodNum === 0 ? 0 : 1,
        enCodeType: 'UTF-8',
        CurrencyNote: this.payment.productName,
        MerchantName: this.payment.MerchantName,
        PeriodNum: this.payment.PeriodNum
      });
    },
    formPost(path, params) {
      let form = document.createElement("form");
      form.setAttribute("method", 'post');
      form.setAttribute("accept-charset", 'UTF-8');
      form.setAttribute("target", '_blank');
      form.setAttribute("action", path);

      console.log(`path=${path}`);
      console.log(`params=${JSON.stringify(params)}`);

      for(let key in params) {
        if(params.hasOwnProperty(key)) {
          const hiddenField = document.createElement("input");
          hiddenField.setAttribute("type", "hidden");
          hiddenField.setAttribute("name", key);
          hiddenField.setAttribute("value", params[key]);
          form.appendChild(hiddenField);
        }
      }
      document.body.appendChild(form);
      form.submit();
    },
    // 超商
    async createMarketPayment(){
      let order = {
        orderId: getUUId(),
        name: this.payment.customerName,
        productName: this.payment.MerchantName,
        memberId: this.memberId,
        cellphone: this.cellphone,
        total: this.payment.price,
        period: this.payment.PeriodNum === 0 ? 1 : this.payment.PeriodNum,
        comment: this.payment.comment,
        paymentList: [],
      };

      await this.createMarketPaymentInfo(this.firstPaymentDate, order);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/TCBPayment.vue